<div class="flex flex-col h-[calc(100vh-2rem)] scrollbar" #anchor>
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <form
      class="flex flex-col p-4 text-caption gap-2 mb-18 h-sm:mb-0"
      [formGroup]="form.group"
    >
      <kendo-formfield>
        <kendo-label
          [for]="direction"
          [text]="'outlook.callLog.direction' | translate"
          >*
        </kendo-label>

        <kendo-dropdownlist
          [data]="direction"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="direction"
          [valuePrimitive]="true"
          required
        >
        </kendo-dropdownlist>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="'outlook.callLog.phone' | translate"></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.phones"
          fillMode="solid"
          formControlName="phone"
          textField="name"
          valueField="name"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [for]="startDate"
          [text]="'outlook.callLog.startDate' | translate"
          >*
        </kendo-label>
        <kendo-datetimepicker
          #startDate
          [format]="outlookStore.fullDateTimeFormat()"
          formControlName="startDate"
          required
          calendarType="classic"
          (valueChange)="onStartChange()"
        >
        </kendo-datetimepicker>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [for]="endDate"
          [text]="'outlook.callLog.endDate' | translate"
          >*
        </kendo-label>
        <kendo-datetimepicker
          #endDate
          [format]="outlookStore.fullDateTimeFormat()"
          formControlName="endDate"
          [min]="now"
          required
          calendarType="classic"
        >
        </kendo-datetimepicker>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [for]="subject"
          [text]="'outlook.callLog.subject' | translate"
          >*
        </kendo-label>
        <kendo-textbox
          formControlName="subject"
          #subject
          required
          [maxlength]="1024"
        ></kendo-textbox>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [text]="'outlook.callLog.category' | translate"
        ></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.callLogOptions?.categories"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="category"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [text]="'outlook.callLog.result' | translate"
        ></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.callLogOptions?.results"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="result"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="'outlook.callLog.callLog' | translate">
        </kendo-label>
        <kendo-textarea
          [rows]="6"
          resizable="vertical"
          formControlName="callLog"
        ></kendo-textarea>
      </kendo-formfield>
    </form>
  }

  <div
    class="bg-neutral-5 z-40 mt-auto flex justify-end gap-2 p-2 bottom-0 sticky"
  >
    <button
      kendoButton
      id="outlook-interactionLog-ui-callLog-cancel"
      class="uppercase"
      themeColor="primary"
      fillMode="flat"
      (click)="cancel()"
      [disabled]="loading"
    >
      {{ 'outlook.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      id="outlook-interactionLog-ui-callLog-save"
      class="uppercase"
      themeColor="primary"
      [disabled]="!canSave"
      (click)="save()"
    >
      {{ 'outlook.buttons.save' | translate }}
    </button>
  </div>
</div>

<maximizer-outlook-notification #notification [closable]="true" entryId="call">
</maximizer-outlook-notification>
